import React, { Component } from "react";
import { Alert, Row, Col, Button, FormGroup, Label, Input, Spinner} from 'reactstrap';
import axios from '../../utils/request';

export class CxmtEvaluationSend extends Component {
    constructor(props) {
        super(props);
        this.state = {
            code: "",
            message: "",
            loading: true,
            commonParamater: null,
            tenantId: "",
            userId: "",
            applyId:""
        }
    };

    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        const commonParamater = urlParams.get("commonParamater");
        const tenantId = urlParams.get("tenantId");
        this.setState({ commonParamater: commonParamater, tenantId: tenantId });
        const params = {
            tenantId,
            commonParamater
        }

        axios
            .get("/api/CxmtEvaluationSend/SendEvaluation", { params: params })
            .then(res => {
                const codeValue = res.data.code;
                let msg = "";
                if (codeValue == 200) {
                    this.setState({ code: codeValue, message: "操作成功!", loading: false })
                } else {
                    this.setState({ code: codeValue, message: res.data.message, loading: false });
                }
            })
            .catch(reason => {
                this.setState({ code: "500", message: "发起失败，请稍后再试！", loading: false })
            });
    };

    render() {
        let contents = ""
        if (this.state.loading) {
            contents = <div style={{ textAlign: "center", padding: "15px" }}>
                <Spinner type="grow" color="primary" />
                <Spinner type="grow" color="secondary" />
                <Spinner type="grow" color="success" />
                <Spinner type="grow" color="danger" />
                <Spinner type="grow" color="warning" />
                <Spinner type="grow" color="info" />
                <Spinner type="grow" color="light" />
                <Spinner type="grow" color="dark" />
            </div>
        } else {
            if (this.state.code == 200) {
                contents =  <div>
                                <Row>
                                    <Col sm="12" md={{ size: 8, offset: 2 }}>
                                        <Alert color="success">
                                            <h4 className="alert-heading">{this.state.message}</h4>
                                            <hr />
                                            <p className="mb-0">请点击右上角关闭此页面。</p>
                                        </Alert>
                                    </Col>
                                </Row>
                            </div >
            }
            else {
                contents = <div>
                                <Row>
                                    <Col sm="12" md={{ size: 8, offset: 2 }}>
                                        <Alert color="danger">
                                            <h4 className="alert-heading"><em>Error...</em> | Code = {this.state.code} | Message = {this.state.message}</h4>
                                            <hr />
                                            <p className="mb-0">请点击右上角关闭此页面。</p>
                                        </Alert>
                                    </Col>
                                </Row>
                            </div >
            }
        }

        return (
            <div>{contents}</div>
        );
    }
}